import { render, staticRenderFns } from "./lead.vue?vue&type=template&id=2662a616&scoped=true&"
var script = {}
import style0 from "./lead.vue?vue&type=style&index=0&id=2662a616&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2662a616",
  null
  
)

export default component.exports